import React from "react";
import {
  Card,
  CardMedia,
  Typography,
  Box,
  Link as MuiLink,
  Grid2,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import "./SettingsCard.css";

const iconMap = {
  MenuBook: { component: MenuBookIcon, className: 'lessons' },
  People: { component: PeopleIcon, className: 'users' },
  Assignment: { component: AssignmentIcon, className: 'userlessons' },
};

const SettingsCard = ({ title, image, icon, subtitle, link }) => {
  const iconData = icon ? iconMap[icon] : null;
  const IconComponent = iconData?.component;
  
  return (
    <Grid2 xs={12} sm={6} className="settings-card-wrapper">
      <MuiLink
        component={Link}
        to={link}
        underline="none"
        color="inherit"
      >
        <Card className="settings-card">
          {IconComponent ? (
            <Box className={`settings-card-icon ${iconData.className}`}>
              <IconComponent />
            </Box>
          ) : (
            image && (
              <CardMedia
                component="img"
                className="settings-card-icon"
                image={image}
                alt={title}
              />
            )
          )}
          <Box className="settings-card-content">
            <Typography className="settings-card-title">
              {title}
            </Typography>
            <Typography className="settings-card-subtitle">
              {subtitle}
            </Typography>
          </Box>
        </Card>
      </MuiLink>
    </Grid2>
  );
};

export default SettingsCard;